module.exports = "/images/id-step1.png?e4c751e7c51b912de19755aceafae61c";